import { useMemo, useState } from 'react';
import { Button, Calendar, Drawer, Flex } from 'antd';
import dayjs from 'dayjs';

const DatePickerMobile = ({ value, onChange, format, disabled, placeholder, disabledDate, ...rest }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  const displayFormat = Array.isArray(format) ? format[0] : format || 'DD/MM/YYYY';

  const label = useMemo(() => {
    if (!value) return placeholder || 'Chọn ngày';
    return dayjs(value).format(displayFormat);
  }, [value, displayFormat, placeholder]);

  const onOpen = () => {
    setSelected(value ? dayjs(value) : null);
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  const onApply = () => {
    if (onChange && selected) {
      onChange(selected, selected.format(displayFormat));
    }
    setOpen(false);
  };

  const onSelectDate = (date) => {
    if (disabledDate && disabledDate(date)) {
      return;
    }
    setSelected(date);
  };

  return (
    <>
      <Button onClick={onOpen} disabled={disabled} style={{ minWidth: 120 }}>
        {label}
      </Button>

      <Drawer title='Chọn ngày' placement='bottom' open={open} onClose={onClose} height='auto'>
        <Calendar
          fullscreen={false}
          value={selected || value ? dayjs(selected || value) : dayjs()}
          onSelect={onSelectDate}
          disabledDate={disabledDate}
        />

        <Flex gap={8} style={{ marginTop: 8 }}>
          <Button block onClick={onClose}>
            Huỷ
          </Button>
          <Button type='primary' block disabled={!selected} onClick={onApply}>
            Áp dụng
          </Button>
        </Flex>
      </Drawer>
    </>
  );
};

export default DatePickerMobile;
